import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { RouteAction } from '@core/action/action';
import { MessageService } from '@core/services/message.service';
import { NotificationService } from '@core/services/notification.service';
import { VinculoService } from '@core/services/vinculo.service';
import { VinculoFormComponent } from '@modules/vinculo/pages/vinculo-form/vinculo-form.component';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import {
  SortCriterion,
  applyColumnSort,
  columnSortOrder,
  columnSortPriority,
  sortQueryParams
} from '@shared/util/multi-sort';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';
import { NzTableSortOrder } from 'ng-zorro-antd/table';

@Component({
  selector: 'app-vinculo-tabela',
  templateUrl: './vinculo-tabela.component.html',
  styleUrls: ['./vinculo-tabela.component.scss']
})
export class VinculoTabelaComponent implements AfterViewInit, OnChanges {

  @Output() atualizarTabelaVinculos = new EventEmitter<any>();
  @Input() pessoa: any;
  @Input() entidade: any;
  @Input() form!: FormGroup;

  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;

  @Input() somenteVisualizar!: any;
  filtro: any;
  sortCriteria: SortCriterion[] = [];
  private shiftPressed = false;
  private lastSortKey: string | null = null;

  constructor(
    private modalService: NzModalService,
    private vinculoService: VinculoService,
    private messageService: MessageService,
    private router: Router,
    private notificationService: NotificationService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.pessoa || this.entidade) {
      this.buscarDados();
    }
  }

  ngAfterViewInit(): void {
    this.paginator.change.subscribe(() => {
      this.buscarDados();
    });
  }

  buscarDados(): void {
    this.filtro = this.pessoa ? { pessoa: this.pessoa?.id } : { entidadeId: this.entidade?.id };
    this.consultar();
  }

  consultar(): void {
    const sortParams = sortQueryParams(this.sortCriteria);

    if (sortParams.sort?.length) {
      this.vinculoService.consultarSort(this.filtro, this.paginator.pagination, sortParams).subscribe((data) => {
        this.dataSet = data.content;
        this.paginator.totalItens = data.totalElements;
      });
      return;
    }

    this.vinculoService.consultarGrid(this.filtro, this.paginator?.pagination).subscribe((data) => {
      this.dataSet = data?.content;
      this.paginator.totalItens = data?.totalElements;
    });
  }

  rememberShift(event: MouseEvent, key: string): void {
    if (event.shiftKey) {
      event.preventDefault();
      window.getSelection()?.removeAllRanges();
    }
    this.shiftPressed = event.shiftKey;
    this.lastSortKey = key;
  }

  onColumnSort(key: string, order: NzTableSortOrder): void {
    if (!order && key !== this.lastSortKey) {
      return;
    }
    this.sortCriteria = applyColumnSort(this.sortCriteria, key, order, this.shiftPressed);
    this.shiftPressed = false;
    this.paginator.reset();
    this.consultar();
  }

  sortOrderOf(key: string): NzTableSortOrder {
    return columnSortOrder(this.sortCriteria, key);
  }

  sortPriorityOf(key: string): number | null {
    return columnSortPriority(this.sortCriteria, key);
  }

  remover(item: any) {
    if (item.id) {
      this.vinculoService.remover(item.id).subscribe(() => {
        this.messageService.success('Vínculo excluído com sucesso!');
        this.buscarDados();
      });
    }
  }

  editar(obj: any) {
    this.showModal(obj);
  }

  goToEntidade(idEntidade: number) {
    if (idEntidade) {
      this.router.navigate([`/entidade/editar/${idEntidade}`]);
    } else {
      this.notificationService.warn(
        'Atenção!',
        `Entidade não encontrada.`
      );
    }
  }

  goToPessoa(idPessoa: number) {
    if (idPessoa) {
      this.router.navigate([`/pessoa/editar/${idPessoa}`]);
    } else {
      this.notificationService.warn(
        'Atenção!',
        `Pessoa não encontrada.`
      );
    }
  }

  novo() {
    this.showModal();
  }

  esconderBotaoRemover(item: any): boolean {
    return !item.id;
  }

  showModal(obj?: any): void {
    const config: ModalOptions<VinculoFormComponent> = {
      nzContent: VinculoFormComponent,
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzWidth: '60vw',
      nzClosable: false,
      nzClassName: 'modal-vinculo',
    };

    const elementFooterBtnsAcao = document.getElementById('footer-btns-fixed');
    if (elementFooterBtnsAcao) {
      elementFooterBtnsAcao.classList.remove('footer-btns-fixed');
    }

    const modalRef = this.modalService.create(config);
    modalRef.componentInstance!.acao = obj ? RouteAction.Editar : RouteAction.Inserir;
    modalRef.componentInstance!.isModal = true;
    modalRef.componentInstance!.pessoa = this.pessoa ? this.pessoa : null;
    modalRef.componentInstance!.idEntidade = this.entidade ? this.entidade?.id : null;
    modalRef.componentInstance!.tipoEntidadeId = this.entidade?.tipoEntidadeId ?? null;
    modalRef.componentInstance!.obj = obj;
    modalRef.componentInstance!.form = this.form;

    modalRef.afterClose.subscribe(() => {
      this.buscarDados();

      if (elementFooterBtnsAcao) {
        elementFooterBtnsAcao.classList.add('footer-btns-fixed');
      }
    });
  }
}
